import { render, staticRenderFns } from "./GlobalDashboardCard_Test.vue?vue&type=template&id=dc7a2c9a&scoped=true&"
import script from "./GlobalDashboardCard_Test.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardCard_Test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7a2c9a",
  null
  
)

export default component.exports